export const formMapValues = (data = {}) => ({
    link_map: data?.link_map ?? "",
  });
  